

















































import Project from "@/lib/Project";
import Vue from "vue";
import Component from "vue-class-component";
import TaskItem from "@/components/TaskItem.vue";
import AddTaskButton from "@/components/AddTaskButton.vue";
import { openDialog } from "@/lib/openDialog";
import Utils from "@/lib/Utils";
import TargetTask from "@/lib/TargetTask";

    @Component({
            components: {TaskItem,AddTaskButton}
        }
    )
    export default class Projects extends Vue {

        projectId ?= "";
        taskNumber = {};
        isAdding = false;
        showFinished = true;

        getLight = Utils.getLight;
        getDark = Utils.getDark;
		

        created():void {
            this.$store.commit("fetchProjectList");
            // this.$store.commit("fetchTaskList");
        }

		get projectLoading():boolean{
			return this.$store.state.projectLoading;
		}

        get finishRate():number {
            let finished = this.taskList.filter(i => i.status === 2).length;
            let all = this.taskList.filter(i => i.status !== 0).length

            return all === 0 ? 0 : Number((finished / all * 100).toFixed());
        }

        get taskList():TargetTask[] {
            const localTaskList = this.$store.state.targetTaskList as TargetTask[];
			if (this.projectId === undefined || this.projectId === ""){
				const projectList  = (this.$store.state.projectList as Project[]);
				if (projectList.length <= 0){
					return [];
				}
				this.projectId = projectList[0].id;
			}
			return localTaskList.filter(i => i.targetId === this.projectId && i.status !== 0);
            // return localTaskList.filter(i => i.targetId === this.projectId && i.status !== 0);
        }

        get projectList():Project[] {
            return (this.$store.state.projectList as Project[]).filter(i => i.status !== 0);
        }

        change(index: number):void {
            console.log(index);
            // if(index === 0) {
            //     this.projectId = "-1";
            // } else {
            //     this.projectId = this.projectList[index - 1].id;
            // }
			this.projectId = this.projectList[index].id;
        }

        deleteTask(id:string):void {
            this.$store.commit("deleteTask",id);
            this.$message({
                 message: '删除成功',
                 type: 'info',
                 showClose: true,
            });
        }

        finishTask(id:string):void {
            this.$store.commit("finishTask",id);
            this.$message({
                 message: '任务已完成',
                 type: 'success',
                 showClose: true,
            });
        }

        openAddProjectDialog(id: string | undefined):void {
            openDialog(id, "AddProjectDialog");
        }
		
    }
